import Typography from "@vapor/react-extended/ExtendedTypography";
import { useDocumentList } from "../../state/useDocumentList";
import Grid from "@vapor/react-material/Grid";

const TrashbinDataDeleteTableHeader = () => {
  const { documentFilterOption } = useDocumentList();
  return (
    <>
      {documentFilterOption === "CESTINO" && (
        <Grid alignItems="center" display="flex" item sm={6}>
          <div>
            <Typography color="primary.textTitleColor" variant="body500">
              Data eliminazione
            </Typography>
          </div>
        </Grid>
      )}
    </>
  );
};

export default TrashbinDataDeleteTableHeader;
